module.exports = __webpack_public_path__ + "static/media/33.caed0659.jpg";